// extracted by mini-css-extract-plugin
export default {"dashboardFilter":"Filter_dashboardFilter__qrkYd","iconFilter":"Filter_iconFilter__M2Zr3"};